export default "/assets/high-active-purple.svg";